import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./index.css";
import "./font-preload.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivacyPolicyRoute from './routes/PrivacyPolicyRoute';
import TosRoute from './routes/TosRoute';
import SupportRoute from './routes/SupportRoute';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="privacy" element={<PrivacyPolicyRoute />} />
          <Route path="tos" element={<TosRoute />} />
          <Route path="support" element={<SupportRoute />} />
        </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
